import React, { useContext, useEffect, useState } from 'react';
import WelcomeFormScreen from '../../ua-brand/welcome-form-screen';
import FormScreen from '../../ua-brand/form-screen';
import OtpScreen from '../../ua-brand/otp-screen';
import AttemptsExhausted from '../../ua-brand/attempts-exhausted';
import ErrorPage500 from '../../ua-brand/error-page-500';
import AlreadyRegistered from '../../promoter/already-registered';
import SuccessRegistered from '../../promoter/success-registered';
import ErrorScreen from '../../lm-d-s/errorScreen';
import useTelegramLink from '../../../hooks/useTelegramLink';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const utm_campaign = sessionStorage.getItem('utm_campaign');

// form-screen та otp-screen перемикають екрани власними номерами
const SHARED_SCREEN_NUMBERS = { 10: 3, 11: 4, 500: 7 };

const PrlS4RegistrationScreen = ({ handleFinish }) => {
  const { telegramLink } = useTelegramLink();
  const { sendEvent } = useContext(DataLayerEventContext);
  const [screenNumber, setScreenNumber] = useState(1);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screenNumber]);

  const setSharedScreenNumber = (number) =>
    setScreenNumber(SHARED_SCREEN_NUMBERS[number] ?? number);

  switch (screenNumber) {
    case 1: {
      return (
        <WelcomeFormScreen
          setScreenNumber={setScreenNumber}
          handleNextScreen={() => {
            sendEvent('registration');
            setScreenNumber(2);
          }}
          isHideSkipButton
          telegramLink={telegramLink}
        />
      );
    }
    case 2: {
      return (
        <FormScreen
          utm_campaign={utm_campaign}
          setScreenNumber={setSharedScreenNumber}
          backButtonClick={() => setScreenNumber(1)}
          telegramLink={telegramLink}
          setFormData={(data) => setFormData(data)}
          formData={formData}
        />
      );
    }
    case 3: {
      return (
        <OtpScreen
          setScreenNumber={setSharedScreenNumber}
          telegramLink={telegramLink}
          handleChangePhoneNumber={() => setScreenNumber(2)}
          successSendOtp={() => {
            sendEvent('passed_authorization');
            setScreenNumber(5);
          }}
          attemptsExhaustedChangeScreen={() => setScreenNumber(6)}
        />
      );
    }
    case 4: {
      return <AlreadyRegistered telegramLink={telegramLink} />;
    }
    case 5: {
      return <SuccessRegistered telegramLink={telegramLink} />;
    }
    case 6: {
      return (
        <AttemptsExhausted
          setScreenNumber={setScreenNumber}
          checkPhoneNumber={() => setScreenNumber(2)}
          telegramLink={telegramLink}
        />
      );
    }
    case 7: {
      return <ErrorPage500 setScreenNumber={handleFinish} />;
    }
    default: {
      return <ErrorScreen setScreenNumber={handleFinish} />;
    }
  }
};

export default PrlS4RegistrationScreen;
